export const PAPER_SIZES = [
  { id: 'A4', label: 'A4', widthMm: 210, heightMm: 297 },
  { id: 'A5', label: 'A5', widthMm: 148, heightMm: 210 },
  { id: 'A3', label: 'A3', widthMm: 297, heightMm: 420 },
  { id: 'LETTER', label: 'US Letter', widthMm: 215.9, heightMm: 279.4 },
];

export const LABEL_SHEET_TEMPLATES = [
  {
    id: 'A4_3x7_63.5x38.1',
    label: 'A4 21 labels (3 × 7) — 63.5 × 38.1mm',
    paperId: 'A4',
    columns: 3,
    rows: 7,
    marginTopMm: 15,
    marginLeftMm: 7,
    pitchXmm: 70,
    pitchYmm: 40,
    labelWidthMm: 63.5,
    labelHeightMm: 38.1,
    cornerRadiusMm: 2,
  },
  {
    id: 'A4_2x4_99.1x67.7',
    label: 'A4 8 labels (2 × 4) — 99.1 × 67.7mm',
    paperId: 'A4',
    columns: 2,
    rows: 4,
    marginTopMm: 12,
    marginLeftMm: 6,
    pitchXmm: 105,
    pitchYmm: 70,
    labelWidthMm: 99.1,
    labelHeightMm: 67.7,
    cornerRadiusMm: 3,
  },
  {
    id: 'LETTER_AVERY_5160',
    label: 'Avery 5160 / 8160 (30 labels) — 2.625\" × 1\"',
    paperId: 'LETTER',
    columns: 3,
    rows: 10,
    marginTopMm: 12.7,
    marginLeftMm: 4.7625,
    pitchXmm: 69.85,
    pitchYmm: 25.4,
    labelWidthMm: 66.675,
    labelHeightMm: 25.4,
    cornerRadiusMm: 2,
  },
  {
    id: 'LETTER_AVERY_5163',
    label: 'Avery 5163 / 8163 (10 labels) — 4\" × 2\"',
    paperId: 'LETTER',
    columns: 2,
    rows: 5,
    marginTopMm: 12.7,
    marginLeftMm: 4.7625,
    pitchXmm: 107.95,
    pitchYmm: 50.8,
    labelWidthMm: 101.6,
    labelHeightMm: 50.8,
    cornerRadiusMm: 3,
  },
  {
    id: 'LETTER_AVERY_5164',
    label: 'Avery 5164 / 8164 (6 labels) — 4\" × 3⅓\"',
    paperId: 'LETTER',
    columns: 2,
    rows: 3,
    marginTopMm: 12.7,
    marginLeftMm: 4.7625,
    pitchXmm: 107.95,
    pitchYmm: 84.666,
    labelWidthMm: 101.6,
    labelHeightMm: 84.666,
    cornerRadiusMm: 3,
  },
];

export const getPaperSizeById = (paperId) => {
  const id = String(paperId || '').toUpperCase();
  return PAPER_SIZES.find((paper) => paper.id === id) || PAPER_SIZES[0];
};

export const getLabelTemplateById = (templateId) => {
  const id = String(templateId || '');
  return LABEL_SHEET_TEMPLATES.find((t) => t.id === id) || LABEL_SHEET_TEMPLATES[0];
};

